import { render, staticRenderFns } from "./readings.vue?vue&type=template&id=4821bcd7"
import script from "./readings.ts?vue&type=script&lang=js&external"
export * from "./readings.ts?vue&type=script&lang=js&external"
import style0 from "./readings.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports